import React from 'react';
import './styles.scss';

const Emag = props => {
    return (
        <div className="emag">
            <iframe title={props.title} src={props.src} allow="fullscreen"></iframe>
        </div>
    );
};

export default Emag;